import { Close, Info } from '@mui/icons-material';
import { Box, Button, IconButton, Modal, Typography } from '@mui/material';
import { useState } from 'react';
import { usePostApiProjectsByIdDeliverableTypesMutation } from '../../../../../../app/athenaApiGen';
import ProjectDeliverableTypeFilter from '../../../../../../components/filters/ProjectDeliverableTypeFilter';
import ProjectFilter from '../../../../../../components/filters/ProjectFilter';
import { EMPTY_PAYLOAD } from '../const';
import { useProjectTypeContext } from '../useProjectTypesContext';

const AddTypeModal = () => {
  const {
    addTypeModal,
    setAddTypeModal,
    setPayload,
    payload,
    projectDelTypeIds,
    setProjectDelTypeIds,
  } = useProjectTypeContext();
  const [error, setError] = useState<string | null>(null);
  const [addType, { isLoading }] =
    usePostApiProjectsByIdDeliverableTypesMutation();

  return (
    <Modal
      open={addTypeModal}
      onClose={() => {
        setAddTypeModal(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '400px',
          backgroundColor: 'var(--template-palette-background-paper)',
          border: '2px solid #000',
          boxShadow:
            '0px 12px 24px 0px rgba(0, 0, 0, 0.2), 0px 16px 48px 0px rgba(0, 0, 0, 0.15)',
          padding: '32px',
        }}
      >
        <Box
          sx={{
            marginBottom: 1,
            pb: 1,
            justifyContent: 'space-between',
            display: 'flex',
            flexDirection: 'row',
            alignSelf: 'center',
          }}
        >
          <Typography variant="h5">Add Deliverable Type</Typography>
          <IconButton size="small" onClick={() => setAddTypeModal(false)}>
            <Close />
          </IconButton>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
          <ProjectFilter
            projectId={payload?.id}
            disabled
            handleChange={(id) => {
              if (id) {
                setPayload((prev) => ({
                  ...prev,
                  id,
                }));
              }
            }}
          />
          <ProjectDeliverableTypeFilter
            multiple
            blacklistTypeIds={projectDelTypeIds}
            deliverableTypeId={
              payload.handlersProjectDeliverableTypesRequest.deliverableTypeIds
            }
            handleChange={(ids) => {
              setPayload((prev) => ({
                ...prev,
                handlersProjectDeliverableTypesRequest: {
                  deliverableTypeIds: ids as string[],
                },
              }));
            }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            mt: 2,
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 1,
            }}
          >
            {error && (
              <>
                <Info sx={{ color: 'red' }} />
                <Typography sx={{ color: 'red' }}>{error}</Typography>
              </>
            )}
          </Box>
          <Button
            disabled={
              !payload.id ||
              payload.handlersProjectDeliverableTypesRequest.deliverableTypeIds
                .length === 0
            }
            variant="contained"
            onClick={async () => {
              try {
                setError(null);
                const data = await addType(payload).unwrap();

                setAddTypeModal(false);
                setPayload((prev) => ({
                  id: prev.id,
                  handlersProjectDeliverableTypesRequest:
                    EMPTY_PAYLOAD.handlersProjectDeliverableTypesRequest,
                }));
                data &&
                  setProjectDelTypeIds((prev) => [
                    ...prev,
                    ...data.map((delTypes) => delTypes.deliverableTypeId ?? ''),
                  ]);
                setError('');
              } catch {
                setError(
                  'Error in Adding Project Deliverable Type, Please Try Again.',
                );
              }
            }}
          >
            {isLoading ? 'Adding...' : 'Add'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddTypeModal;
